import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';


export default class ContractsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args
        var sortField = null
        var sortOrder = null

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {
              args: args, 
              nameCriteria: "",
              prevNameCriteria: "",
              sortField: sortField, 
              sortOrder: sortOrder,
              fromDate: null,
              roDate: null,
              contracts: []
        }

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)
    }  
    
    async componentDidMount() {
        this.getDataWithCritera()
        setTimeout(this.nameSearch, 2000);
    }

    getDataWithCritera() {

        var parameters = {}
        
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

    
        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/contracts', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({contracts: res.data})
        })    
        .catch(error=>console.log(error))
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "startCaption" :
                if (currentField === "start") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "start"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "endCaption" :
                if (currentField === "end") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "end"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder}, this.getDataWithCritera)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    fromDateChangeHandler(event) {
        this.setState({fromDate: event.target.value}, this.getDataWithCritera)
    }

    toDateChangeHandelr(event) {
        this.setState({toDate: event.target.value}, this.getDataWithCritera)
    }
    
    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            this.setState({prevNameCriteria: this.state.nameCriteria}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    openContract(id) {
        this.props.navigate("contract", {caller: "contracts", callargs: this.state.args, contract: id})
    }

    renderContract(contract) {
        return (
            <div class="row" style={{"height" : "50px"}}>
                    <div class="col-3 text-left border border-white" 
                         style={{"background-color" : "#eee"}}>{contract.name}</div>
                    <div class="col-4 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{contract.description}</div>
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{contract.start}</div>     
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{contract.end}</div> 
                    <div class="col-1 border border-white"
                         style={{"background-color" : "#eee"}} onClick={()=>this.openContract(contract.id)}><img src={details} height="16" width="16"/></div>
            </div>
        )      
    }

    render() {
        return (
            <div class="container">
            <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Контракты"}/>
            <div class="mt-5 col-md-4">
                    <form title="Фильтр">
                        <div class="form-group">
                            <label for="name">Наименование:</label>
                            <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />   
                        </div>
                    </form>
                </div>
            <div class="row mt-5" style={{"height" : "50px"}}>
                    <div class="col-3 text-left border border-white"
                        id="nameCaption"
                        onClick={this.sortClicked}  
                        style={{"background-color" : "#0ee"}}>
                        Наименование
                        {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                        {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-4 text-left border border-white"
                        style={{"background-color" : "#0ee"}}>Описание</div>
                    <div class="col-2 text-left border border-white"
                        id="startCaption"
                        onClick={this.sortClicked}  
                        style={{"background-color" : "#0ee"}}>
                        Начало
                        {this.isFieldSortedDesc("start") && <img src={sortdesc} height="16" width="16"/>}
                        {this.isFieldSortedAsc("start") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-2 text-left border border-white"
                        id="endCaption"
                        onClick={this.sortClicked}
                        style={{"background-color" : "#0ee"}}>
                        Окончание
                        {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                        {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>           
                    <div class="col-1 border border-white"
                        style={{"background-color" : "#0ee"}}
                        onClick={()=>{this.openContract("")}}><img src={add} height="16" width="16"/>
                    </div>     
                </div>    
           
            {this.state.contracts.map((value, index) => this.renderContract(value))}
        </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/contracts.js